export function delay<T>(func: () => T | Promise<T>, ms: number): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    try {
      setTimeout(() => {
        Promise.resolve().then(func).then(resolve).catch(reject);
      }, ms);
    } catch (error) {
      reject(error);
    }
  });
}
